<div class="row">
    <div class="col-md-3 text-left">
        <ul class="options-cadastro m-0 pl-0">
            <li>
                <h5>Pagamentos</h5>
            </li>
            <li class="list-select ml-2 my-1">
                <button class="list-select" type="button" (click)="pageChanged(1)">
                    <img src="assets/icons/update-arrow.svg" style="height: 15px;">
                    Atualizar
                </button>
            </li>
        </ul>
    </div>
    <div class="col-md-9 text-right" *ngIf="true">
        <ul class="options-cadastro m-0">
            <li>
                <div *ngIf="exibirFiltro && filtroOn" (click)="deleteFilter(filtro)" class="list-select ml-2
                    my-1">
                    <button class="list-select-delete" type="button">
                        Apagar filtro
                    </button>
                </div>
            </li>
            <li>
                <div *ngIf="exibirFiltro" (click)="showFilter(filtro)" class="list-select ml-2
                    my-1">
                    <button class="list-select"  type="button">
                        <span *ngIf="!filtroOn"><img src="assets/icons/filter.svg" style="height: 15px;"> Aplicar filtro</span>
                        <span *ngIf="filtroOn"><img src="assets/icons/filter-purple.svg" style="height: 15px;"> Alterar filtro</span>
                    </button>
                </div>
            </li>
            <li>
                <div class="list-select-search-input ml-2 my-1">
                    <input class="w-100 ng-untouched ng-pristine
                        ng-valid" placeholder="Pesquise aqui..." type="search" [(ngModel)]="filtroPesquisa" (keyup.enter)="pageChanged(1)" />
                </div>
            </li>
            <li>
                <div class="list-filter-show-item ml-2 my-1">
                    Mostrar:
                    <select (change)="showItemChanged($event.target.value)" class="ng-untouched ng-pristine ng-valid">
                        <option _ selected="" value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                </div>
            </li>
        </ul>
    </div>
</div>

<div class="row">
    <div class="col-12 p-0 text-left">
        <ul class="options-cadastro pl-0 m-0">
            <li>
                <div (click)="exportExtractExcel()" class="list-select ml-2 my-1">
                    <button _ngcontent-khv-c20="" class="list-select"  type="button">
                        <span>Exportar Excel</span>
                    </button>
                </div>
            </li>
            <li>
                <div (click)="exportExtractPdf()" class="list-select ml-2 my-1">
                    <button _ngcontent-khv-c20="" class="list-select"  type="button">
                        <span>Exportar PDF</span>
                    </button>
                </div>
            </li>
        </ul>
    </div>
</div>

<div class="row mt-5">
    <div class="col-12">
        <ng-container *ngFor="
                let item of intencoesDeposito
                    | paginate
                        : {
                              itemsPerPage: showItem,
                              currentPage: currentPage,
                              totalItems: totalItems
                          }
            ">
        </ng-container>

        <div class="table-responsive">
            <table class="table table-bordered table-striped" id="dataTable" width="100%" cellspacing="0" *ngIf="true">
                <thead>
                    <tr>
                        <th (click)="
                                sortOrder = !sortOrder;
                                orderBy('intencaoDepositoId', sortOrder)
                            ">
                            Código
                        </th>
                        <th (click)="
                                sortOrder = !sortOrder;
                                orderBy('referencia', sortOrder)
                            ">
                            Referência
                        </th>
                        <th (click)="
                                sortOrder = !sortOrder;
                                orderBy('compra', sortOrder)
                            ">
                            Código da recarga
                        </th>
                        <th (click)="
                                sortOrder = !sortOrder;
                                orderBy('tipo', sortOrder)
                            ">
                            Tipo
                        </th>
                        <th (click)="
                                sortOrder = !sortOrder;
                                orderBy('status', sortOrder)
                            ">
                            Status
                        </th>
                        <th (click)="
                                sortOrder = !sortOrder;
                                orderBy('valor', sortOrder)
                            ">
                            Valor
                        </th>
                        <th (click)="
                                sortOrder = !sortOrder;
                                orderBy('emissao', sortOrder)
                            ">
                            Emissão
                        </th>
                        <th (click)="
                                sortOrder = !sortOrder;
                                orderBy('Vencimento', sortOrder)
                            ">
                            Vencimento
                        </th>
                        <th (click)="
                                sortOrder = !sortOrder;
                                orderBy('processamento', sortOrder)
                            ">
                            Processamento
                        </th>
                        <th (click)="
                                sortOrder = !sortOrder;
                                orderBy('cancelamento', sortOrder)
                            ">
                            Cancelamento
                        </th>
                        <th>Ações</th>
                    </tr>
                </thead>
                <tbody class="list-table-row">
                    <tr *ngFor="
                            let item of intencoesDeposito
                                | paginate
                                    : {
                                          itemsPerPage: showItem,
                                          currentPage: currentPage,
                                          totalItems: totalItems
                                      }
                        ">
                        <td class="clickable">
                            {{ item.intencaoDepositoId }}
                        </td>
                        <td class="clickable">
                            <span *ngIf="item.identificador">{{
                                item.identificador
                            }}</span>
                            <span *ngIf="!item.identificador">Sem referência</span
                            >
                        </td>
                        <td class="clickable">
                            <span *ngIf="item.compraId">{{ item.compraId }}</span>
                            <span *ngIf="!item.compraId">-</span
                            >
                        </td>
                        <td class="clickable">
                            {{ item.tipoDeposito }}
                        </td>
                        <td class="clickable">
                            {{ item.status }}
                        </td>
                        <td>
                            {{ item.valor | currency: "BRL":true }}
                        </td>
                        <td class="clickable">
                            {{ item.dataCadastro | date: "dd/MM/yyyy HH:mm" }}
                        </td>
                        <td class="clickable">
                            <span *ngIf="item.dataVencimento">{{ item.dataVencimento | date: "dd/MM/yyyy" }}</span>
                            <span *ngIf="!item.dataVencimento">-</span>
                        </td>
                        <td class="clickable">
                            <span *ngIf="item.dataProcessamento">{{
                                item.dataProcessamento
                                    | date: "dd/MM/yyyy HH:mm"
                            }}</span>
                            <span *ngIf="!item.dataProcessamento && !item.dataCancelamento">{{ item.status}}</span
                            >
                            <span *ngIf="item.dataCancelamento">{{ item.status }}</span
                            >
                        </td>
                        <td class="clickable">
                            <span *ngIf="item.dataCancelamento">{{
                                item.dataCancelamento
                                    | date: "dd/MM/yyyy"
                            }}</span>
                            <span *ngIf="!item.dataCancelamento">-</span
                            >
                        </td>
                        <!--MENU-->
                        <td>
                            <div
                                ngbDropdown
                                class="d-inline-block
                                menu-option"
                                placement="left"
                            >
                                <button
                                    class="dropdown-button"
                                    id="dropdown-menu"
                                    ngbDropdownToggle
                                >
                                    <img src="assets/icons/menu.png" />
                                </button>
                                <div
                                    ngbDropdownMenu
                                    aria-labelledby="dropdown-menu"
                                    class="p-0 m-0"
                                >
                                    <section
                                        class="custom-context-menu"
                                    >
                                        <div
                                            ngbDropdownItem
                                            *ngIf="
                                                item.dataProcessamento ===
                                                    null &&
                                                (item.tipoDepositoId ===
                                                    null ||
                                                    item.tipoDepositoId ===
                                                        2)
                                            "
                                            (click)="
                                                showVisualizarIntencaoDeposito(
                                                    visualizarIntencaoDeposito,
                                                    item.intencaoDepositoId
                                                )
                                            "
                                        >
                                            <img
                                                src="assets/icons/contrato.png"
                                            />
                                            Visualizar intenção de
                                            depósito
                                        </div>
                                        <div
                                            ngbDropdownItem
                                            *ngIf="
                                                item.tipoDepositoId ===
                                                    1 &&
                                                item.dataProcessamento ===
                                                    null &&
                                                item.dataCancelamento ===
                                                    null &&
                                                item.boletoInfo
                                            "
                                            (click)="
                                                showVisualizarBoleto(
                                                    item
                                                )
                                            "
                                        >
                                            <img
                                                src="assets/icons/contrato.png"
                                            />
                                            Visualizar boleto
                                        </div>
                                        <div
                                            ngbDropdownItem

                                            (click)="
                                                showVisualizarRPS(
                                                    item.intencaoDepositoId
                                                )
                                            "

                                            *ngIf="
                                                !item.dataCancelamento
                                            "
                                        >
                                            <img
                                                src="assets/icons/contrato.png"
                                            />
                                            Visualizar RPS
                                        </div>
                                        <div
                                            ngbDropdownItem
                                            *ngIf="
                                                item.tipoDepositoId ===
                                                    1 &&
                                                item.dataProcessamento ===
                                                    null &&
                                                item.dataCancelamento ===
                                                    null &&
                                                item.boletoInfo === null
                                            "
                                            (click)="gerarBoleto(item)"
                                        >
                                            <img
                                                src="assets/icons/contrato.png"
                                            />
                                            Gerar boleto
                                        </div>
                                        <div
                                            ngbDropdownItem
                                            *ngIf="
                                                item.tipoDepositoId ===
                                                    1 &&
                                                item.dataProcessamento ===
                                                    null &&
                                                item.dataCancelamento ===
                                                    null &&
                                                item.boletoInfo &&
                                                item.boletoInfo
                                                    .situacaoId === 3 &&
                                                !item.boletoInfo
                                                    .segundaVia
                                            "
                                            (click)="gerarBoleto(item)"
                                        >
                                            <img
                                                src="assets/icons/contrato.png"
                                            />
                                            Gerar boleto 2ª via
                                        </div>
                                        <div
                                            ngbDropdownItem
                                            *ngIf="
                                                item.dataProcessamento
                                            "
                                            (click)="
                                                showVisualizarReciboIntencaoDeposito(
                                                    visualizarRecibo,
                                                    item.intencaoDepositoGuid
                                                )
                                            "
                                        >
                                            <img
                                                src="assets/icons/contrato.png"
                                            />
                                            Gerar recibo
                                        </div>
                                        <div ngbDropdownItem *ngIf="item.temNFSE" (click)="showVisualizarNFSE(item.intencaoDepositoGuid)">
                                            <img src="assets/icons/contrato.png"/>
                                            Baixar Nota Fiscal
                                        </div>
                                        <div ngbDropdownItem *ngIf="item.compraId" (click)="toPurchaseDetails(item.compraId)">
                                            <img src="assets/icons/shopp-car-purple.png"/>
                                            Detalhes da recarga
                                        </div>
                                        <div ngbDropdownItem *ngIf="
                                                item.tipoDepositoId ==
                                                5 
                                            " (click)="showQRCodePagar(modalQRCodePagar, item, item.brCodePIX)">
                                                <img src="assets/icons/comprovante.png" class="mr-2" /> Mostrar QR Code
                                            </div>
                                        <div ngbDropdownItem *ngIf="item.dataProcessamento === null && item.dataCancelamento === null"
                                            (click)="cancelarDeposito(item.intencaoDepositoId)">
                                                <img src="assets/icons/garbage-purple.png" class="mr-2" /> Cancelar
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div
                *ngIf="intencoesDeposito.length === 0"
                class="text-center"
            >
                <h6>
                    Nenhuma intenção de depósito carregada. Faça uma
                    busca para retornar a lista de intenções de depósito
                    ou faça uma inteção de depósito.
                </h6>
            </div>

            <div class="page-custom mt-2">
                <pagination-controls
                    (pageChange)="pageChanged($event)"
                    responsive="true"
                    previousLabel=""
                    nextLabel=""
                ></pagination-controls>
            </div>
        </div>
    </div>
</div>


<!--Modal do Filtro-->
<ng-template #filtro let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Aplicar filtro</h5>
        </div>
    </div>
        <div class="row col-12 clean-modal-content">
            <div class="col-lg-4 col-md-6 col-sm-12 my-4">
                <div class="custom-filter-input-container">
                    <mat-form-field>
                        <input id="startDate" matInput [matDatepicker]="startDate" placeholder="Data Início" [value]="dataInicio"  (dateChange)="setPeriod(true,$event.value)"/>
                        <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
                        <mat-datepicker #startDate></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12 my-4">
                <div class="custom-filter-input-container">
                    <mat-form-field>
                        <input id="endDate" matInput [matDatepicker]="endDate" placeholder="Data Fim" [value]="dataFim"  (dateChange)="setPeriod(false,$event.value)"/>
                        <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
                        <mat-datepicker #endDate></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12 my-4">
                <div class="custom-filter-input-container">
                    <mat-form-field class="example-form-field">
                        <input [formControl]="codeCtrl" matInput type="text" placeholder="Código" [(ngModel)]="filtroCodigo">
                        <button mat-button *ngIf="filtroCodigo" matSuffix mat-icon-button aria-label="Clear" (click)="filtroCodigo=''">
                            <mat-icon>close</mat-icon>
                        </button>
                        </mat-form-field>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12 my-4">
                <div class="custom-filter-input-container">
                    <mat-form-field class="example-form-field">
                        <input [formControl]="refenceCtrl"  matInput type="text" placeholder="Referência" [(ngModel)]="filtroReferencia">
                        <button mat-button *ngIf="filtroReferencia" matSuffix mat-icon-button aria-label="Clear" (click)="filtroReferencia=''">
                            <mat-icon>close</mat-icon>
                        </button>
                        </mat-form-field>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12 my-4">
                <div class="custom-filter-input-container">
                    <mat-form-field class="example-form-field">
                        <input [formControl]="valueCtrl" [textMask]="{mask: MASKS.currency.textMask}" matInput type="text" placeholder="Valor" [(ngModel)]="filtroValor">
                        <button mat-button *ngIf="filtroValor" matSuffix mat-icon-button aria-label="Clear" (click)="filtroValor=''">
                            <mat-icon>close</mat-icon>
                        </button>
                        </mat-form-field>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12 my-4">
                  <div class="custom-filter-input-container">
                    <mat-form-field>
                        <input [formControl]="issueDateCtrl" id="issueDate" [max]="maxDate" matInput [matDatepicker]="issueDate" placeholder="Emissão" [value]="filtroEmissao"/>
                        <mat-datepicker-toggle matSuffix [for]="issueDate"></mat-datepicker-toggle>
                        <mat-datepicker #issueDate></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12 my-4">
                <div class="custom-filter-input-container">
                    <mat-form-field>
                        <input [formControl]="processingDateCtrl" id="processingDate" matInput [matDatepicker]="processingDate" placeholder="Processamento" [value]="filtroProcessamento" />
                        <mat-datepicker-toggle matSuffix [for]="processingDate"></mat-datepicker-toggle>
                        <mat-datepicker #processingDate></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12 my-4">
                <div class="custom-filter-input-container">
                    <mat-form-field>
                        <input [formControl]="cancelationDateCtrl" id="cancelationDate" [max]="maxDate" matInput [matDatepicker]="cancelationDate" placeholder="Cancelamento" [value]="filtroCancelamento" />
                        <mat-datepicker-toggle matSuffix [for]="cancelationDate"></mat-datepicker-toggle>
                        <mat-datepicker #cancelationDate></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="col-12 clean-modal-footer">
            <button class="custom-filter-button custom-filter-button-just" type="button" (click)="applyFilter();" ngbAutofocus>
                Aplicar
            </button>
        </div>
</ng-template>


<!--Visualizar Intenção de Depósito-->
<ng-template #visualizarIntencaoDeposito let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="modal-title clean-modal-title">
                Intenção de depósito
            </h5>
            <p class="clean-modal-subtitle">
                Visualize abaixo os dados da intenção de depósito.
            </p>
        </div>
    </div>
    <div class="col-12 clean-modal-content">
        <div class="clean-modal-section-title">Conta de origem</div>
        <div class="clean-modal-text">
            <span class="clean-modal-span">Banco:</span> {{ intencaoDepositoDetalhes.origemBancoNome }}
        </div>
        <div class="clean-modal-text">
            <span class="clean-modal-span">Número do banco:</span> {{ intencaoDepositoDetalhes.origemBanco }}
        </div>
        <div class="clean-modal-text">
            <span class="clean-modal-span">Agência:</span> {{ intencaoDepositoDetalhes.origemAgencia }}
            <span *ngIf="intencaoDepositoDetalhes.origemDigitoAgencia">-{{ intencaoDepositoDetalhes.origemDigitoAgencia }}</span>
        </div>
        <div class="clean-modal-text">
            <span class="clean-modal-span">Conta:</span> {{ intencaoDepositoDetalhes.origemConta }}
            <span *ngIf="intencaoDepositoDetalhes.origemDigitoConta">-{{ intencaoDepositoDetalhes.origemDigitoConta }}</span>
        </div>
        <br />
        <div class="clean-modal-section-title">Transfira para</div>
        <div class="clean-modal-text">
            <span class="clean-modal-span">Banco:</span> {{ intencaoDepositoDetalhes.destinoBancoNome }}
        </div>
        <div class="clean-modal-text">
            <span class="clean-modal-span">Número do banco:</span> {{ intencaoDepositoDetalhes.destinoBanco }}
        </div>
        <div class="clean-modal-text">
            <span class="clean-modal-span">Agência:</span> {{ intencaoDepositoDetalhes.destinoAgencia }}
            <span *ngIf="intencaoDepositoDetalhes.destinoDigitoAgencia">-{{ intencaoDepositoDetalhes.destinoDigitoAgencia }}</span>
        </div>
        <div class="clean-modal-text">
            <span class="clean-modal-span">Conta:</span> {{ intencaoDepositoDetalhes.destinoConta }}
            <span *ngIf="intencaoDepositoDetalhes.destinoDigitoConta">-{{ intencaoDepositoDetalhes.destinoDigitoConta }}</span>
        </div>
        <div class="clean-modal-text">
            <span class="clean-modal-span">Código de identificação:</span> {{ intencaoDepositoDetalhes.intencaoDepositoId }}
        </div>
        <div class="clean-modal-text">
            <span class="clean-modal-span">Favorecido:</span> {{ intencaoDepositoDetalhes.destinoRazaoSocial }}
        </div>
        <div class="clean-modal-text" *ngIf="intencaoDepositoDetalhes.origemBanco !== intencaoDepositoDetalhes.destinoBanco">
            <span class="clean-modal-span">CNPJ:</span> {{ intencaoDepositoDetalhes.destinoCNPJ.toString() | cnpj }}
        </div>
    </div>

    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel" type="button" (click)="modal.dismiss('Close click')">
        Fechar
        </button>
    </div>
</ng-template>

<!-- Modal do recibo -->
<ng-template #visualizarRecibo let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="modal-title clean-modal-title">
                Recibo
            </h5>
            <p class="clean-modal-subtitle">
                Visualize abaixo os dados do seu recibo.
            </p>
        </div>
    </div>
    <div class="col-12 clean-modal-content">
        <div class="clean-modal-section-title">Comprovante de pagamento</div>
        <div class="clean-modal-text" *ngIf="reciboIntencaoDeposito.guidId">
            <span class="clean-modal-span">Código da transação:</span> {{ reciboIntencaoDeposito.guidId }}
        </div>
        <div class="clean-modal-text" *ngIf="reciboIntencaoDeposito.id">
            <span class="clean-modal-span">Pagamento:</span> {{ reciboIntencaoDeposito.id }}
        </div>
        <div class="clean-modal-text" *ngIf="reciboIntencaoDeposito.meioPagamento">
            <span class="clean-modal-span">Forma de Pagamento:</span> {{ reciboIntencaoDeposito.meioPagamento }}
        </div>
        <div class="clean-modal-text" *ngIf="reciboIntencaoDeposito.dataProcessamento">
            <span class="clean-modal-span">Data de Processamento:</span> {{ reciboIntencaoDeposito.dataProcessamento | date: "dd/MM/yyyy" }}
        </div>
        <div class="clean-modal-text" *ngIf="reciboIntencaoDeposito.valorPedido">
            <span class="clean-modal-span">Total pedido:</span> {{ reciboIntencaoDeposito.valorPedido | currency: "BRL":true }}
        </div>
        <div class="clean-modal-text" *ngIf="reciboIntencaoDeposito.valorPago">
            <span class="clean-modal-span">Total pago:</span> {{ reciboIntencaoDeposito.valorPago | currency: "BRL":true }}
        </div>
        <div *ngIf="reciboIntencaoDeposito.identificador" class="clean-modal-text">
            <span class="clean-modal-span">Identificador:</span> {{ reciboIntencaoDeposito.identificador }}
        </div>
        <hr *ngIf="reciboIntencaoDeposito.pagadorNomeJuridico || reciboIntencaoDeposito.pagadorNomeFantasia"/>
        <div class="clean-modal-section-title" *ngIf="reciboIntencaoDeposito.pagadorNomeJuridico || reciboIntencaoDeposito.pagadorNomeFantasia">Pagador</div>
        <div class="clean-modal-text" *ngIf="reciboIntencaoDeposito.pagadorNomeJuridico">
            <span class="clean-modal-span">Razão social:</span> {{ reciboIntencaoDeposito.pagadorNomeJuridico }}
        </div>
        <div class="clean-modal-text" *ngIf="reciboIntencaoDeposito.pagadorNomeFantasia">
            <span class="clean-modal-span">Nome fantasia:</span> {{ reciboIntencaoDeposito.pagadorNomeFantasia }}
        </div>
        <hr />
        <div class="clean-modal-section-title">Recebedor</div>
        <div class="clean-modal-text" *ngIf="reciboIntencaoDeposito.recebedor">
            <span class="clean-modal-span">Razão social:</span> {{ reciboIntencaoDeposito.recebedor }}
        </div>


    </div>

    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel" type="button" (click)="modal.dismiss('Close click')">
        Fechar
        </button>
    </div>
</ng-template>

<ng-template #modalQRCodePagar let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <div class="col-12 modal-header clean-modal-header">
                <div class="col-md-12 row" style="place-content: center;">
                    <h5 class="modal-title clean-modal-title mb-3">
                       Utilize o QR Code PIX abaixo para realizar o pagamento
                    </h5>
                    <div class="col-6 text-center">
                        <img src="{{'data:image/gif;base64,' + brCodePix.imagemBRCode}}" class="qrcode-img"/>

                    </div>
                    <div class="col-6 detalhes-QRCode">
                        <h6 class="dados-qrcode-modal">Você está pagando:</h6>
                        <span >{{brCodePix.valor| currency}}</span>
                        <h6 class="dados-qrcode-modal">Para a empresa:</h6>
                        <span >Bankei Beneflex Benefícios e Similares S/A</span>
                        <h6 class="dados-qrcode-modal">A ser creditado na conta digital de:</h6>
                        <span > {{assignorInfo.nickName}}</span>
                        <h6 class="dados-qrcode-modal">QR Code:</h6>
                        <span >{{brCodePix.brCode}}</span>
                    </div>
                    <!-- <p class="clean-modal-subtitle">
                        {{qrCodePix.brCode}}
                    </p> -->
                    <div class="col-12 mt-2">
                        <button class="btn btn-outline-danger btn-fechar-modal-qrcode" type="button" (click)="modal.dismiss('Close click')">
                            Fechar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--  -->
</ng-template>
